/**
 * Re-export for backwards compatibility.
 * The component has been moved to ./component-settings-dialog/component-settings-dialog.tsx
 */
export { ComponentSettingsDialog } from "./component-settings-dialog/component-settings-dialog";
export type { ComponentSettingsDialogProps } from "./component-settings-dialog/component-settings-types";
